<div class="screen">

  <!-- ── Hero ── -->
  <div class="hero-card" [attr.data-tension]="tensionKey()">

    <span class="hero-badge" [attr.data-tension]="tensionKey()">
      <span class="hero-badge-dot" [attr.data-tension]="tensionKey()"></span>
      {{ tensionLabel() }}
    </span>
    <div class="hero-top">
      <h1 class="hero-name">{{ site.nom }}</h1>
    </div>

    @if (site.statut !== 'ferme') {
      <div class="hero-metrics">
        <div class="hero-metric">
          <span class="hm-lbl">{{ 'mobileSimulator.common.surSite' | translate }}</span>
          <span class="hm-val">{{ site.presenceEstimee }}</span>
        </div>
        <div class="hm-sep"></div>
        <div class="hero-metric">
          <span class="hm-lbl">{{ 'mobileSimulator.siteDetail.activityLabel' | translate }}</span>
          <span class="hm-val hm-val--text">{{ site.activite }}</span>
        </div>
      </div>
    }

    @if (site.descInfo) {
      <div class="hero-derive">
        <span class="derive-dot"></span>
        <span>{{ site.descInfo }}</span>
      </div>
    }

  </div>

  <!-- ── Timeline ── -->
  @if (site.statut !== 'ferme' && site.timeline.length) {
    <p class="section-label section-label--link">{{ 'mobileSimulator.common.historique' | translate }}</p>
    <div class="card-timeline">
      @for (slot of getTimelineSlots(); track slot; let i = $index) {
        <div class="tl-col">
          <span class="tl-dot" [style.background]="tlColor(site.timeline[i])"></span>
          <span class="tl-time">{{ slot }}</span>
        </div>
      }
    </div>
  }

  <!-- ── Alertes ── -->
  @if (site.alertes.length) {
    <p class="section-label section-label--link">{{ 'mobileSimulator.siteDetail.alertsTitle' | translate }}</p>
    <div class="alertes-list">
      @for (alerte of site.alertes; track alerte.text) {
        <div class="alerte-item" [attr.data-type]="alerte.type">{{ alerte.text }}</div>
      }
    </div>
  }

  <!-- ── Actions rapides ── -->
  @if (site.statut !== 'ferme') {
    <p class="section-label section-label--link">{{ 'mobileSimulator.common.actionsRapides' | translate }}</p>

    @if (actionSent()) {
      <div class="confirm-toast">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
        <span>{{ 'mobileSimulator.common.actionEnvoyee' | translate }} · <strong>{{ actionSent() }}</strong></span>
      </div>
    }

    <div class="actions-grid">
      @for (action of actions; track action.id) {
        <button class="action-card" (click)="action.id === 'patient' ? openCommPatient.emit() : action.id === 'canal' ? openCanal.emit() : action.id === 'degrade' ? openModeDegrade.emit() : action.id === 'renfort' ? openRenfort.emit() : sendAction(action.label)">
          <span class="action-icon">{{ action.icon }}</span>
          <span class="action-label">{{ action.label }}</span>
        </button>
      }
    </div>
  }

  <!-- ── Résumé IA ── -->
  @if (tensionSince()) {
    <p class="section-label section-label--link">{{ 'mobileSimulator.siteDetail.analysisTitle' | translate }}</p>
    <div class="ai-summary">
      <span class="ai-icon">✦</span>
      <p>{{ tensionSince() }}</p>
    </div>
  }

</div>